import React, { useState, useEffect } from 'react';
import { Container, Typography, Grid, Card, CardContent, CardMedia, Box, Button } from '@mui/material';
import { config } from '../config';

function Videos() {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchVideos();
  }, []);

  const fetchVideos = async () => {
    try {
      const response = await fetch(config.endpoints.videos);
      if (response.ok) {
        const data = await response.json();
        setVideos(data);
      }
    } catch (error) {
      console.error('Error fetching videos:', error);
    } finally {
      setLoading(false);
    }
  };

  // Extract YouTube video ID from URL
  const getYouTubeId = (url) => {
    if (!url) return null;
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
  };

  const getThumbnailUrl = (youtubeId) => `https://img.youtube.com/vi/${youtubeId}/hqdefault.jpg`;

  if (loading) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Typography>Loading videos...</Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Astrophotography Videos
      </Typography>
      <Grid container spacing={4}>
        {videos.map((video) => {
          const youtubeId = getYouTubeId(video.url);
          return (
            <Grid item xs={12} sm={6} md={4} key={video.id}>
              <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <Box sx={{ mb: 2 }}>
                  {youtubeId ? (
                    <Box
                      component="a"
                      href={video.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{
                        display: 'block',
                        position: 'relative',
                        textDecoration: 'none',
                        color: 'inherit'
                      }}
                    >
                      <CardMedia
                        component="img"
                        image={getThumbnailUrl(youtubeId)}
                        alt={video.title}
                        sx={{
                          aspectRatio: '16 / 9',
                          objectFit: 'cover',
                          backgroundColor: 'background.default'
                        }}
                      />
                      <Button
                        variant="contained"
                        size="small"
                        sx={{
                          position: 'absolute',
                          left: '50%',
                          top: '50%',
                          transform: 'translate(-50%, -50%)',
                          pointerEvents: 'none'
                        }}
                      >
                        Play
                      </Button>
                    </Box>
                  ) : (
                    <Typography color="error" sx={{ p: 2 }}>
                      Invalid YouTube URL
                    </Typography>
                  )}
                </Box>
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography gutterBottom variant="h6" component="h2">
                    {video.title}
                  </Typography>
                  {video.description && (
                    <Typography variant="body2" color="text.secondary">
                      {video.description}
                    </Typography>
                  )}
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Container>
  );
}

export default Videos;
